import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import AutosuggestInput from '@Components/AutosuggestInput';
import { SELECT_WRAP_SYMBOL, STOP_WORDS } from './QuickSearchAutosuggestConstants';

import './QuickSearchAutosuggest.theme.scss';

function Autosuggest({
  inputValue = '',
  debounceDelay = 150,
  fetchAutosuggestMatches,
  isLoading,
  inputOnChange,
  onSelect,
  buildQuery,
  placeholder,
}) {
  const spinnerScale = 1;

  const stopWords = useMemo(
    () => [`${SELECT_WRAP_SYMBOL} `, ...STOP_WORDS.map((sw) => `${sw} `)],
    []
  );

  const onSelectPreProcessor = (selected) =>
    `${SELECT_WRAP_SYMBOL}${selected}${SELECT_WRAP_SYMBOL}`;

  return (
    <span className="react-qs-autosuggest">
      <AutosuggestInput
        idInput="id-quick-search-input"
        classNameInput="e2e-quick-search-input search-form-input els-text-input-field nohyphens"
        value={inputValue}
        onChange={inputOnChange}
        getData={fetchAutosuggestMatches}
        debounceDelay={debounceDelay}
        onSelect={onSelect}
        stopWords={stopWords}
        onSelectPreProcessor={onSelectPreProcessor}
        groupBy="category"
        highlight
        buildQuery={buildQuery}
        placeholder={placeholder}
      />
      {isLoading && (
        <RxSpinnerComponent
          autoStart
          spinnerScale={spinnerScale}
          spinnerId="typeahead-spinner"
        />
      )}
    </span>
  );
}

Autosuggest.propTypes = {
  inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  debounceDelay: PropTypes.number,
  fetchAutosuggestMatches: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  inputOnChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  buildQuery: PropTypes.object,
  placeholder: PropTypes.string,
};

export default Autosuggest;
